export default "__VITE_ASSET__CP$oW01w__"